@if (row1 && row1.contentColumns.length > 0 && currentContentIndex != 0 && languageId === defaultLanguageId && !inMobileEditor) {
  <a class="resize-icons left-arrow" id="test-{{column.id}}" (click)="sideArrowResize(true, column.id)"
    title="resize content width by 5%"
    >
  </a>
}
@for (row of column.contentRows| orderBy:'order'; track row) {
<section [hidden]="row.isDeleted" id="row-{{row.id}}" [ngClass]="{'dark': row.contentBlock?.shaded == true,
  'ui-resize-section98': (row1 && row1.contentColumns.length === 3 && row1.contentColumns.length -1 != currentContentIndex
  && languageId === defaultLanguageId),
  'ui-resize-section97': (row1 && row1.contentColumns.length === 5 && row1.contentColumns.length -1 != currentContentIndex
  && languageId === defaultLanguageId)}"
    class="custom-row row min-height100" dndDropzone (dndDrop)="onDrop($event, row)" (dndDragover)="onDragover($event)">
    <div class="edit-options-wrapper"
      [ngClass]="{'edit-options-wrapper-blue': editRowId == row.id && !level, 'edit-options-wrapper-grey': isRowBox && isShowEditRowWrapperGrey == row.id && editRowId != row.id && !level}"
      [dndDraggable]="draggableWithDragMoveContent" (dndStart)="onDragRowStart($event, row,container.id)"
      (dndEnd)="onDragEnd($event)" (dndDrag)="onDrag($event, true)"
      [dndDisableIf]="languageId !== defaultLanguageId || editRowId !== row.id || isDragDropAllowed" style="width: 100%;">
      @if (editRowId == row.id && !level) {
        <div [ngClass]="{'edit-icon-bg-1': languageId !== defaultLanguageId }" class="edit-icon-bg-right"
          >
          @if (languageId === defaultLanguageId && !inMobileEditor) {
            <ul class="edit-icon-2">
              <li>
                <i class="material-icons copy-content--element" title="Copy"
                (click)="copyPlaybookContent(row, true)">file_copy</i>
              </li>
              <li dndHandle>
                <i class="material-icons move-content--element" title="Move" (mousedown)="disableDragDrop(false)">
                  <span class="editor-content-block hidden"></span>
                  open_with
                </i>
              </li>
              <li>
                <i (click)="deleteRow(row, true)" class="material-icons delete-content--element" title="Delete">delete</i>
              </li>
            </ul>
          }
        </div>
      }
      @if (!inMobileEditor) {
        @for (column of row.contentColumns| orderBy: 'order'; track column; let currentContentIndex = $index) {
          @if (!column.isDeleted) {
            <app-content-box (updateSectionEvent)="updateSectionEvent.next($event)" [contentColumn]="column"
              class="custom-col col grid-{{column.columnWidth}}" id="column-{{column.id}}"
              [parentSectionId]="parentSectionId" [level]="level + 1" [container]="container" [tElement]="tElement"
              [row1]="row" [currentContentIndex]="currentContentIndex" [pageTemplateId]="pageTemplateId"
              [hideContent]="hideContent" [reorderContent]="reorderContent"
              (changeContentRow)="changeContentDataFunc($event)">
            </app-content-box>
          }
        }
      } @else {
        @for (column of row.contentColumns; track column; let currentContentIndex = $index) {
          @if (!column.isDeleted) {
            <app-content-box (updateSectionEvent)="updateSectionEvent.next($event)" [contentColumn]="column"
              class="custom-col col grid-{{column.columnWidth}}" id="column-{{column.id}}"
              [parentSectionId]="parentSectionId" [level]="level + 1" [container]="container" [tElement]="tElement"
              [row1]="row" [currentContentIndex]="currentContentIndex" [pageTemplateId]="pageTemplateId"
              [hideContent]="hideContent" [reorderContent]="reorderContent"
              (changeContentRow)="changeContentDataFunc($event)">
            </app-content-box>
          }
        }
      }
      @if (row.contentBlock!=null) {
        <div
          [ngClass]="{'edit-options-wrapper edit-options-wrapper-blue': editContentBlockId == row.contentBlock.id}"
          style="width: 100%; position: relative;" [dndDraggable]="draggableWithDragMoveContent"
          (dndStart)="onDragStart($event, row, container.id)" (dndEnd)="onDragEnd($event)" (dndDrag)="onDrag($event)"
          [dndDisableIf]="languageId !== defaultLanguageId || editContentBlockId !== row.contentBlock.id || isDragDropAllowed"
          (click)="articleClick(row.contentBlock,$event)">
          @if (editContentBlockId == row.contentBlock.id) {
            <div [ngClass]="{'edit-icon-bg-1': languageId !== defaultLanguageId }" class="edit-icon-bg"
        [ngStyle]="{'width': !isSafari && getContentTypeForIcon(row.contentBlock.type)
      ? !inMobileEditor ? '172px' : reorderContent ? row.totalButtonWidth  : '36px'
      : !inMobileEditor ? '' : reorderContent ? row.totalButtonWidth : '36px', 'padding': reorderContent && row.totalButtonWidth == '0px' ? '0px' : '5px' }">
              @if (!reorderContent) {
                <ul class="edit-icon-2">
                  <li [ngClass]="{'disableli': row.contentBlock.type == 1}">
                    <i (click)="settingContentBlock(row.contentBlock)" [ngClass]="{'disableedit': row.contentBlock.type == 1}"
                      id="editor--content-{{row.contentBlock.id}}" class="material-icons setting-content--element"
                    title="Settings">create</i>
                  </li>
                  @if (!isSafari && languageId === defaultLanguageId && getContentTypeForIcon(row.contentBlock.type) && !inMobileEditor) {
                    <li [ngClass]="{'disableli': selectedContentBlock?.id == row.contentBlock.id }"
                      >
                      <i [ngClass]="{'disableedit': selectedContentBlock?.id == row.contentBlock.id }"
                        class="material-icons copy-content--element" title="Animation"
                      (click)="settingAnimationBlock(row.contentBlock)">animation</i>
                    </li>
                  }
                  @if (languageId === defaultLanguageId && !inMobileEditor) {
                    <li>
                      <i class="material-icons copy-content--element" title="Copy"
                      (click)="copyPlaybookContent(row.contentBlock)">file_copy</i>
                    </li>
                  }
                  @if (languageId === defaultLanguageId  && !inMobileEditor) {
                    <li dndHandle>
                      <i class="material-icons move-content--element" title="Move" (mousedown)="disableDragDrop(false)"><span
                      class="editor-content-block hidden"></span>open_with</i>
                    </li>
                  }
                  @if (languageId === defaultLanguageId && !inMobileEditor) {
                    <li>
                      <i (click)="deleteRow(row)" class="material-icons delete-content--element" title="Delete">delete</i>
                    </li>
                  }
                </ul>
              }
            </div>
          }
          <article class="content-block" id="content-block-{{row.contentBlock.id}}">
            @switch (row.contentBlock.type) {
              @case (4) {
                <div>
                  <div>
                    <app-image class="content-block-content content-block-image" style="position: relative;"
                      [isdraftmode]="container.isCurrentPageInDraftMode" [contentBlock]="row.contentBlock"
                      [containerId]="container.id" [pageTemplateId]="pageTemplateId" [sectionId]="parentSectionId">
                    </app-image>
                  </div>
                </div>
              }
              @case (5) {
                <div>
                  <app-video class="content-block-content content-block-video" style="position: relative;"
                    [isdraftmode]="container.isCurrentPageInDraftMode" [contentBlock]="row.contentBlock"
                    [containerId]="container.id" [pageTemplateId]="pageTemplateId" [sectionId]="parentSectionId">
                  </app-video>
                </div>
              }
              @case (6) {
                <div>
                  <div>
                    <app-audio class="content-block-content content-block-audio" style="position: relative;"
                      [isdraftmode]="container.isCurrentPageInDraftMode" [contentBlock]="row.contentBlock"
                      [containerId]="container.id" [pageTemplateId]="pageTemplateId" [sectionId]="parentSectionId">
                    </app-audio>
                  </div>
                </div>
              }
              @case (3) {
                <div>
                  <div>
                    <app-tab class="content-block-content content-block-tabs" style="position: relative;"
                      [contentBlock]="row.contentBlock" [parentSectionId]="parentSectionId" [level]="level + 1"
                      [pageTemplateId]="pageTemplateId" [container]="container" [playbookId]="playbookId"
                      (tabChange)="changeTabFunc($event)" [reorderContent]="reorderContent" [hideContent]="hideContent">
                    </app-tab>
                  </div>
                </div>
              }
              @case (16) {
                <div>
                  <div>
                    <app-challenge-block class="content-block-content content-block-tabs" style="position: relative;"
                      [contentBlock]="row.contentBlock" [pageTemplateId]="pageTemplateId" [sectionId]="parentSectionId"
                      [level]="level + 1" [container]="container">
                    </app-challenge-block>
                  </div>
                </div>
              }
              @case (1) {
                <div>
                  <div class="content-block-text para custom-table" id="editable-{{row.contentBlock.id}}"
                    (click)="disableDragDrop(true)">
                    @if (row.contentBlock) {
                      <div>
                        @if (!isSafari) {
                          <app-text-animation [contentBlockId]="row.contentBlock.id"
                            [basicTextContent]="row.contentBlock.basicTextContent" (textFocus)="articleClick(row.contentBlock)"
                            (textBlur)="onBlur($event, row.contentBlock, row.contentBlock.basicTextContent)"
                            [animationState]="row.contentBlock.animationState" [animationType]="animationType"
                            [animationDirection]="animationDirection" [isContentEditable]="!reorderContent">
                          </app-text-animation>
                        }
                        @if (isSafari) {
                          @if (!reorderContent) {
                            <div id="contentblock-{{row.contentBlock.id}}"
                              [inlineMenuId]="'content-block-menu-' + row.contentBlock.id"
                              [innerHTML]="row.contentBlock.basicTextContent | safe:'html'"
                              class="content-style content-block-content" appCKEditor [customConfig]="false"
                              (ckFocus)="articleClick(row.contentBlock)"
                              (ckBlur)="onBlur($event,row.contentBlock,row.contentBlock.basicTextContent)" contenteditable="true">
                            </div>
                          } @else {
                            <div id="contentblock-{{row.contentBlock.id}}"
                              [innerHTML]="row.contentBlock.basicTextContent | safe:'html'"
                              class="content-style content-block-content">
                            </div>
                          }
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            }
          </article>
        </div>
      }
      @if (row.contentColumns.length > 1 && languageId === defaultLanguageId  && !inMobileEditor) {
        <a class="icon-even" (click)="evenRowColumns(row)" title="even out column widths"
          >
        </a>
      }
      @if (editRowId != row.id && !level && languageId === defaultLanguageId && !inMobileEditor) {
        <span class="show-edit-hover"
          (mouseenter)="showHideRowEditSelectionArea(row.id) " (mouseleave)="showHideRowEditSelectionArea(null)">
          @if (!level && isRowBox) {
            <div [ngClass]="{'edit-icon-bg-1': languageId !== defaultLanguageId }" class="icon-bg-right-edit">
              <ul class="edit-icon-2">
                @if (languageId === defaultLanguageId) {
                  <li><i class="material-icons copy-content--element" title="Edit Row"
                  (click)="rowClick(row,$event)">create</i>
                </li>
              }
            </ul>
          </div>
        }
      </span>
    }
  </div>
  @if (!isSafari && selectedContentBlock && row.contentBlock && selectedContentBlock?.id == row.contentBlock?.id) {
    <div class="animation-box move-content--element" id="animation-menu" (click)="stopAnimationClose($event)"
      >
      <ul>
        <li class="animation-box-title">Edit Animations</li>
        <hr>
          @if (getContentTypeForDialog(row.contentBlock?.type)) {
            <li style="width: 100%;">
              <app-image-animation [animationState]="row.contentBlock.animationState" [animationType]="animationType"
                [animationDirection]="animationDirection">
              </app-image-animation>
            </li>
          }
          @for (animation of animationList; track animation) {
            <li class="animation-editor-block pointer"
              (click)="changeAnimation(animation)">
              <span class="editor-content-block" [ngClass]="{'selected-animation' : animation.selected == true}">
                <img [src]="'../../../assets/img/' + animation.image" alt="">
              </span>
              <span style="font-size: 14px;">{{animation.title}}</span>
            </li>
          }
        </ul>
        <div class="row align-items-center" style="position: relative;left: 35px;">
          <label class="control-label col-sm-3">Direction</label>
          <div class="col-sm-5">
            <ng-select placeholder="--Select--" [items]="dropdownList" bindLabel="title" [(ngModel)]="animationDirection"
              [disabled]="!animationType" [multiple]="false" bindValue="value" (change)="onAnimationSelect()">
            </ng-select>
          </div>
          <div class="col-sm-2">
            <i [ngClass]="{'disableedit': !animationDirection }" (click)="deleteAnimation(row)"
            class="material-icons delete-content--element pointer" title="Delete">delete</i>
          </div>
        </div>
        <hr>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="animation-box-footer">
              <button type="button" style="margin: 0.25rem;" class="btn btn__btn-default vPlaybookDefaultButton"
              (click)="closeAnimationBox()">Cancel</button>
              <button type="button" style="margin: 0.25rem;" class="btn btn__btn-default btn__orange"
              (click)="saveAnimation()" [disabled]="!animationType || !animationDirection">Save</button>
            </div>
          </div>
        </div>
      }
    </section>
  }
  @if (row1 && row1.contentColumns.length -1 != currentContentIndex && languageId === defaultLanguageId
    && !inMobileEditor) {
    <a class="resize-icons right-arrow" id="test-{{column.id}}" (click)="sideArrowResize( false, column.id)" title="resize content width by 5%">
    </a>
  }
  @if (!column.contentRows.length) {
    <section class="norow col" dndDropzone (dndDrop)="onDrop($event)"
      (dndDragover)="onDragover($event)" id="column-{{column.id}}">
    </section>
  }